/**
 * WordPress dependencies
 */
import { createRoot } from '@wordpress/element';

/**
 * Internal dependencies
 */
import EventsApp from './components/EventsApp';

/**
 * Import styles
 */
import '../../css/events-app.css';
import '../../css/events-list.css';
import '../../css/pagination.css';
import '../../css/event-hero.css';

// Mount the React app
document.addEventListener( 'DOMContentLoaded', () => {
	const container = document.getElementById(
		'nemtly-booking-create-event-app'
	);

	// Only render if the container exists
	if ( container ) {
		const root = createRoot( container );
		root.render( <EventsApp /> );
	}
} );
